import React from "react";
import { MAGICBI_LOGO_SRC } from "../../../constants/brandAssets";
import {
  Outer,
  BelowGroup,
  LeadingTile,
  Container,
  TitleGroup,
  LogoImg,
  Title,
  TitleText,
  Subtitle,
  EndGroup,
  CollapseButton,
} from "./ChatPanelHeader.styles";
import type { ChatPanelHeaderProps } from "./ChatPanelHeader.types";

/**
 * Chat panel header (Figma node 3812:42285): MagicBI logo + "MagicBI AI"
 * title on the left, a collapse control on the right. Stateless molecule —
 * collapse state lives in the parent organism.
 */
export const ChatPanelHeader: React.FC<ChatPanelHeaderProps> = ({
  title = "MagicBI AI",
  onCollapse,
  subtitle,
  endSlot,
  leadingTile,
  isRoundCollapse = false,
  belowSlot,
}) => (
  <Outer>
  <Container>
    <TitleGroup>
      {leadingTile ? (
        <LeadingTile aria-hidden>{leadingTile}</LeadingTile>
      ) : (
        <LogoImg src={MAGICBI_LOGO_SRC} alt="" aria-hidden />
      )}
      {subtitle ? (
        <TitleText>
          <Title>{title}</Title>
          <Subtitle>{subtitle}</Subtitle>
        </TitleText>
      ) : (
        <Title>{title}</Title>
      )}
    </TitleGroup>
    {endSlot ? <EndGroup>{endSlot}</EndGroup> : null}
    <CollapseButton
      type="button"
      $isRound={isRoundCollapse}
      onClick={onCollapse}
      aria-label="Collapse chat panel"
    >
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden>
        <path
          d="M3 5L3 19C3 20.1046 3.89543 21 5 21L19 21C20.1046 21 21 20.1046 21 19L21 5C21 3.89543 20.1046 3 19 3L5 3C3.89543 3 3 3.89543 3 5Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 10L12 14L8 10"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </CollapseButton>
  </Container>
  {belowSlot ? <BelowGroup>{belowSlot}</BelowGroup> : null}
  </Outer>
);

export default ChatPanelHeader;
